import { Tooltip } from "antd";
import { useState } from "react";

import { stakingRiskTooltips } from "../../../Utils/stakingrisk_tooltipTexts";
import styles from "./staking-risk.module.css";
import { getValueColor } from "./helper";

 
export default function SingleRiskDetails({ selectedProduct }) {
 const [visible, setVisible] = useState(false);
  return (
    <div className={styles["product-details"]}>
      {selectedProduct?.stakingRiskAssessments?.map((item, index) => {
      const normalizedName = item.name.toLowerCase().trim();
        return(
        <div key={index} className={styles["product-details-items"]}>
          <h4 className={styles["product-details-items-title"]}>
            {item.name}
              <Tooltip
                placement="rightTop"
                 title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            stakingRiskTooltips[selectedProduct.key.toLowerCase()]?.[normalizedName]
                              ?.replace(/\n/g, "<br/>"),
                        }}
                      />
                    }
                 color={"#364048"}
                 onOpenChange={(visible) => setVisible(visible)}
                 overlayInnerStyle={{ width: "550px", height: "auto" }}
                  >
                <i
                  className="icon-Vector"
                  style={{ position: "relative", left: "1%", top: "2px" }}></i>
                 </Tooltip>
            </h4>
              <span className={styles["product-details-items-level"]}  
                    style={{color: getValueColor(item.scoreLevel,item.key) || "#e0e0e0"}}>{item.scoreLevel}</span>
          <div className={styles["line"]}></div>
            <h4 className={styles["w-score"]} style={{ lineHeight: "35px" }}>
              Description:
            </h4>
            <p className={styles["product-details-items-description"]} style={{ whiteSpace: "pre-line" }}>
              {item?.comment?.replace(/<br\s*\/?>/gi, "\n")}
            </p>
        </div>
)})}
    </div>
  );
}